const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const diferenciais = [
  {
    icon: 'ri-time-line',
    titulo: 'Agilidade',
    descricao: 'Resposta imediata em situações urgentes. Estamos disponíveis para atender quando você mais precisa, sem burocracia ou demora.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    titulo: 'Estratégia',
    descricao: 'Cada caso é tratado com planejamento individualizado. Analisamos todas as nuances para construir a melhor defesa possível.',
  },
  {
    icon: 'ri-lock-line',
    titulo: 'Discrição',
    descricao: 'Confidencialidade absoluta em todos os casos. Seu sigilo e privacidade são garantidos em cada etapa do atendimento.',
  },
  {
    icon: 'ri-user-line',
    titulo: 'Atendimento Direto',
    descricao: 'Você fala diretamente com o advogado responsável pelo seu caso, sem intermediários e com total transparência.',
  },
];

export default function Diferenciais() {
  return (
    <section className="py-[60px] bg-[#F8F5EE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Por que nos escolher
            </span>
            <span className="h-px w-12 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-[#0A1829] font-light mb-4">
            Nossos <span className="italic text-[#B39B62]">Diferenciais</span>
          </h2>
          <p className="font-sans text-[#0A1829]/60 text-base max-w-xl mx-auto leading-relaxed">
            Elementos que definem nossa forma de atuar e nosso compromisso com cada cliente, em todas as áreas de atuação jurídica.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {diferenciais.map((item, index) => (
            <div
              key={item.titulo}
              className="bg-white border border-[#E9D59C]/40 rounded-lg p-8 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Number */}
              <span className="font-serif text-6xl text-[#E9D59C] font-light leading-none mb-4 select-none">
                {String(index + 1).padStart(2, '0')}
              </span>
              {/* Icon Circle */}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#B39B62]/20 border border-[#B39B62]/40 mb-5">
                <i className={`${item.icon} text-[#0A1829] text-lg`}></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-3">{item.titulo}</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">{item.descricao}</p>
            </div>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="text-center">
          <p className="font-sans text-[#0A1829]/55 text-sm mb-5">
            Precisa de assessoria jurídica? Fale com nossa equipe agora.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#0A1829] hover:bg-[#B39B62] text-white hover:text-[#0A1829] font-sans font-semibold text-sm px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Solicitar atendimento pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
